import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExpiresAtComponent } from './expires-at.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

@NgModule({
  declarations: [ExpiresAtComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    BsDatepickerModule.forRoot(),    
  ],
  exports:[ExpiresAtComponent],

})
export class ExpiresAtModule { }
